<div #stepHolder
     class="td-wb-joyride-step__holder"
     [attr.id]="'td-wb-joyride-step-' + step().name"
     aria-modal="true"
     role="dialog"
     [style.top.px]="topPosition"
     [style.left.px]="leftPosition">
  @if (showArrow) {
    <td-wb-joyride-arrow class="td-wb-joyride-step__arrow"
                         [position]="arrowPosition"
                         [style.top.px]="arrowTopPosition"
                         [style.left.px]="arrowLeftPosition"/>
  }

  <div #stepContainer class="td-wb-joyride-step__container">
    @let titleText = title | async;
    @let bodyText = text | async;
    @let customLabelText = customLabel | async;
    @if (!step().usedAsCoachMark) {
      <div class="td-wb-joyride-step__image">
        <img  alt="Guided Tour Step Icon"
              [src]="iconSrc"
              width="235px"
              height="130px"/>
      </div>
      <div class="td-wb-joyride-step__content">
        @if (isCloseButtonVisible) {
          <td-wb-joyride-close-button class="td-wb-joyride-step__close"
                                      (clicked)="close()"/>
        }
        <h2 class="td-wb-joyride-step__header">
          <div class="td-wb-joyride-step__title"
               [innerText]="titleText"></div>
        </h2>
        <div class="td-wb-joyride-step__body">
          <span [innerHTML]="bodyText"></span>
        </div>
        <div class="td-wb-joyride-step__footer">
          <div class="td-wb-joyride-step__footer-left">
            @if (isPrevButtonVisible && !standalonePrevButton) {
              <td-wb-joyride-back-button
                class="td-wb-joyride-step__back-button"
                (clicked)="back()">
                @if (isCounterVisible) {
                  <div
                    class="td-wb-joyride-step__counter"
                    translate="tdWb.core.joyride.step.COUNTER"
                    [translateParams]="counter">
                  </div>
                }
              </td-wb-joyride-back-button>
            } @else if (isCounterVisible) {
              <div
                class="td-wb-joyride-step__counter"
                translate="tdWb.core.joyride.step.COUNTER"
                [translateParams]="counter">
              </div>
            }
          </div>
          <div class="td-wb-joyride-step__footer-right">
            @if (isPrevButtonVisible && standalonePrevButton) {
              <td-wb-joyride-button
                buttonType="tertiary"
                class="td-wb-joyride-step__prev-button"
                (clicked)="back()">
                <span translate="tdWb.core.joyride.step.PREVIOUS"></span>
              </td-wb-joyride-button>
            }
            @if (!isLastStep()) {
              <td-wb-joyride-button (clicked)="next()">
                <span translate="tdWb.core.joyride.step.NEXT"></span>
              </td-wb-joyride-button>
            } @else {
              <div class="td-wb-joyride-step__done-container td-wb-joyride-step__button">
                <td-wb-joyride-button class="td-wb-joyride-step__done-button"
                                      buttonId="td-wb-joyride-step-done-button"
                                      (clicked)="close(true)">
                  @if (customLabelText) {
                    <span [innerText]="customLabelText"></span>
                  } @else {
                    <span translate="tdWb.core.joyride.step.DONE"></span>
                  }
                </td-wb-joyride-button>
              </div>
            }
          </div>
        </div>
      </div>
    } @else {
      <div class="td-wb-joyride-step__content">
        <td-wb-joyride-close-button class="td-wb-joyride-step__close"
                                    (clicked)="close()"/>
        <h2 class="td-wb-joyride-step__header td-wb-joyride-step__header--coach-mark">
          <div class="td-wb-joyride-step__title"
               [innerText]="titleText"></div>
        </h2>
        <div class="td-wb-joyride-step__body">
          <span [innerText]="bodyText"></span>
        </div>
      </div>
    }
  </div>
</div>


